<template>
  <div class="containter">
    <div class="row" v-for="(item, index) in msg" :key="index">
      <div>
        <div class="left">
          <div v-if="item.msg_type == 2">
            <a :href="'/useractivity?uid='+item.opt_uid" class="user">{{ item.opt_uid_name }}</a
            >赞了我的文章
          </div>
          <div v-if="item.msg_type == 1">
            <a :href="'/useractivity?uid='+item.opt_uid" class="user">{{ item.opt_uid_name }}</a
            >评论了我的文章
          </div>
          <div v-if="item.msg_type == 0"><a :href="'/useractivity?uid='+item.opt_uid" class="user">{{ item.opt_uid_name }}</a
            >{{ item.msg }}</div>
          <div class="date">{{dateFormat(item.createdate)}}</div>
        </div>
        <div class="right">
          <a :href="'/video?id='+item.cont_id+'&uid='+item.uid">
        </a></div>
      </div>
      <div class="divider"></div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>

<style scoped>
.containter {
  background-color: white;
  padding: 16px;
  font-size: 15px;
}
.row {
  padding: 12px;
}
.user {
  font-weight: bold;
  margin-right: 8px;
}
.date {
  color: #999;
  font-size: 12px;
  line-height: 22px;
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.divider {
  background-color: #e2e2e2;
  height: 0.5px;
  width: 100%;
  float: right;
  margin-top: 12px;
  margin-bottom: 12px;
  padding-left: 12px;
}
.left {
  float: left;
  text-align: left;
}
.right {
  float: right;
}
</style>

<script>
export default {
  mounted() {
      this.getMsg();
  },
  data() {
    return {
      msg: [],
    };
  },
  methods: {
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    getMsg() {
      //消息通知
      this.$http
        .get("/api/message")
        .then((r) => {
          this.msg = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
